import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-568e712d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btns" }

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  JuouProForm,
  JuouProFormItem,
  useBaseAsync,
  useBaseUserStore,
  useBaseTenantStore,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, watch } from 'vue';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'publish',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;


const columns = ref<JuouProTableColumn[]>([]);
const setFormRef = ref<InstanceType<typeof JuouProForm>>();

const visible = ref(false);
const weapp = ref({} as any);
const tpl = ref<any>();

const currentDraftId = ref<number>();

const items = ref<JuouProFormItem[]>([]);

const initValues = ref({} as any);

watch(visible, () => {
  if (!visible.value) {
    emit('close');
  }
});

const init = useBaseAsync(() => {
  columns.value = [
    {
      name: 'draftId',
      label: '草稿ID',
      type: 'number',
    },
    {
      name: 'currentVersion',
      label: '版本',
      type: 'string',
    },
    {
      name: 'description',
      label: '描述',
      type: 'string',
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: ({ row: { createTime } }: any) => dayjs(createTime).format('YYYY-MM-DD HH:mm:ss'),
    },

  ];
});


const loading = ref(false);

const formData = ref({} as any);

const handleFormChange = useBaseAsync((data: any) => {
  console.log(data);
  formData.value = { ...data };
});


const handlePublish = useBaseAsync(async() => {
  console.log(formData.value);
  try {
    loading.value = true;
    const res = await useApi().weappApi.publishWeappweapp({
      appid: weapp.value.appid,
      ext: formData.value,
    });
    ElMessage.success('提交发布审核成功');
    visible.value = false;
  } finally {
    loading.value = false;
  }
});


init();
__expose({
  show: async(_weapp: any, _tpl: any) => {
    let tenant: any;
    try {
      const res = await useApi().tenantApi.getTenantComInfotenant();
      console.log(res);
      if (res?.data?.data) {
        tenant = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }


    weapp.value = _weapp;
    tpl.value = _tpl;
    items.value = _tpl?.extjsFormItems?.map((item: any) => {
      if (_weapp.ext?.[item.name] !== undefined) {
        initValues.value[item.name] = _weapp.ext?.[item.name];
      } else if (item.tenantKey && tenant?.[item.tenantKey]) {
        initValues.value[item.name] = tenant?.[item.tenantKey];
      }
      if (item.required) {
        item.rule = [{ required: true }];
      }
      if (item.type === 'image') {
        return {
          ...item,
          action: useApi().uploadImageUrl,
          multiple: false,
          onSuccess(data: any) {
            console.log(data.data[0]);
            setFormRef.value?.setOneFormState(item.name, data.data[0]);
          },
        };
      }
      return item;
    }) || [];

    console.log(initValues.value);
    visible.value = true;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "配置发布",
    draggable: "",
    width: "50vw",
    "lock-scroll": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, { style: {"height":"60vh"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions, { title: "模板信息" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "模板名称" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tpl.value?.name || '未知'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "模板版本" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tpl.value?.currentVersion || '未知'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (visible.value && items.value.length)
            ? (_openBlock(), _createBlock(_unref(JuouProForm), {
                key: 0,
                ref_key: "setFormRef",
                ref: setFormRef,
                "init-form-value": initValues.value,
                title: "配置模板",
                items: items.value,
                "hide-cancel": true,
                "hide-ok": true,
                onChange: _unref(handleFormChange)
              }, null, 8, ["init-form-value", "items", "onChange"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = () => visible.value = false)
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(handlePublish),
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("发布")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})